import { inject } from "vue";

export const XMessageKey = Symbol("XMessage");

export interface XMessageApi {
  show(content: string, options?: { color?: string; timeout?: number }): void;
  success(content: string, options?: { timeout?: number }): void;
  error(content: string, options?: { timeout?: number }): void;
  warning(content: string, options?: { timeout?: number }): void;
  info(content: string, options?: { timeout?: number }): void;
}

export function useXMessage(): XMessageApi {
  const api = inject<XMessageApi>(XMessageKey);
  if (!api) {
    throw new Error(
      "[XMessage]: useXMessage() must be used inside a component wrapped with <XMessage>. Add <XMessage> in App.vue."
    );
  }
  return api;
}
